import axiosInstance from "./axiosInstance";

export interface MaxCoverageLimit {
  safetyTime: number;
  coverageProfile: number;
}

export const getMaxCoverage = async (
  plantId: string | number,
): Promise<MaxCoverageLimit> => {
  const response = await axiosInstance.get<MaxCoverageLimit>(
    `/api/max-coverage/${plantId}`,
  );
  return response.data;
};
